import { rpc } from './client.js';

// sps_login and sps_session are `returns table (...)`, so PostgREST hands back an
// array of rows even though there is only ever one. Callers want the row.
// (The mock returns the row directly, hence the Array check rather than [0].)
const firstRow = (r) => (Array.isArray(r) ? (r[0] ?? null) : r);

export const login = (code, name, pin, device) =>
  rpc('sps_login', {
    p_code: code,
    p_name: name,
    p_pin: pin ?? null,
    p_device: device ?? null,
  }).then(firstRow);

// A list is genuinely a list — no unwrapping here.
export const staffList = (code) => rpc('sps_staff_list', { p_code: code });

export const whoami = (token) => rpc('sps_session', { p_token: token }).then(firstRow);
